import * as R from "ramda";
import fuzzysearch from "fuzzysearch";

export const search = (criteria = "", string = "") =>
  fuzzysearch(
    removeAccents(criteria.toLowerCase()),
    (removeAccents(string) || "").toLowerCase()
  );

export const removeAccents = str =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const pluralsForList = R.compose(
  R.gt(R.__, 1),
  R.length
);

export const initials = candidate => {
  const first = str => (str && str.length > 0 ? str[0].toUpperCase() : "");
  let result = "";
  let fullname;

  if (candidate.first && candidate.last) {
    fullname = [candidate.first, candidate.last];
  } else {
    fullname = R.split(" ", R.propOr(" ", "fullname", candidate));
  }

  if (fullname.length > 1) {
    result = `${first(fullname[0])}${first(fullname[1])}`;
  } else {
    result = first(fullname[0]);
  }

  return result;
};
